import * as z from "zod";

export const ScanVerifyPopupSchema = z.object({
  title: z.string(),
  description: z.string().nullable(),
  blocking: z.boolean().optional(),
});
export type ScanVerifyPopup = z.infer<typeof ScanVerifyPopupSchema>;

export const getScanVerifyPopups = {
  name: "getScanVerifyPopups" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({ popups: z.array(ScanVerifyPopupSchema) }),
};
